import { FilterIcon } from 'lucide-react'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

export interface PortalControlButtonTriggerProps {
  className?: string
  onClick: VoidFunction
}

export const PortalControlTriggerButton = ({ className, onClick }: PortalControlButtonTriggerProps) => {
  return (
    <Button type="button" size="sm" variant="secondary" className={cn('flex gap-x-2', className)} onClick={onClick}>
      <FilterIcon size={16} />
      Portal Control
    </Button>
  )
}
